import "@/App.css";
import { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import { Toaster } from "@/components/ui/sonner";
import { platforms } from "@/data/mock";

const PlatformReview = lazy(() => import("@/pages/PlatformReview"));
const About = lazy(() => import("@/pages/About"));
const Compare = lazy(() => import("@/pages/Compare"));
const TrustCenter = lazy(() => import("@/pages/TrustCenter"));
const EditorialPolicy = lazy(() => import("@/pages/EditorialPolicy"));
const Disclosure = lazy(() => import("@/pages/Disclosure"));
const Corrections = lazy(() => import("@/pages/Corrections"));
const ComparisonsLanding = lazy(() => import("@/pages/ComparisonsLanding"));
const Admin = lazy(() => import("@/pages/Admin"));
const Methodology = lazy(() => import("@/pages/Methodology"));
const NotFound = lazy(() => import("@/pages/NotFound"));
const PrivacyPolicy = lazy(() => import("@/pages/PrivacyPolicy"));
const TermsOfUse = lazy(() => import("@/pages/TermsOfUse"));
const TopicPage = lazy(() => import("@/pages/TopicPage"));
const Contact = lazy(() => import("@/pages/Contact"));

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Suspense fallback={<div data-testid="page-loading-fallback" />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/compare" element={<Compare />} />
          <Route path="/compare/:pairSlug" element={<Compare />} />
          <Route path="/ecommerce-comparisons" element={<ComparisonsLanding />} />
          <Route path="/methodology" element={<Methodology />} />
          <Route path="/trust-center" element={<TrustCenter />} />
          <Route path="/editorial-policy" element={<EditorialPolicy />} />
          <Route path="/disclosure" element={<Disclosure />} />
          <Route path="/corrections" element={<Corrections />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          <Route path="/admin" element={<Admin />} />
          <Route
            path="/best-ecommerce-builders"
            element={
              <TopicPage
                title="E-Commerce Builders: Current Editorial Comparison"
                description="A source-coverage table for ecommerce website builders, with numeric scores withheld and evidence gaps disclosed."
                path="/best-ecommerce-builders"
              />
            }
          />
          <Route
            path="/best-ai-ecommerce-platforms"
            element={
              <TopicPage
                title="AI E-Commerce Platforms: Current Editorial Comparison"
                description="A current editorial comparison of AI-related ecommerce capabilities under the published methodology."
                filterKey="ai"
                path="/best-ai-ecommerce-platforms"
              />
            }
          />
          <Route
            path="/best-mobile-ecommerce-platforms"
            element={
              <TopicPage
                title="Mobile E-Commerce Platforms: Current Editorial Comparison"
                description="A current editorial comparison of mobile shopping, cart and checkout criteria under the published methodology."
                filterKey="mobile"
                path="/best-mobile-ecommerce-platforms"
              />
            }
          />
          <Route
            path="/best-for-small-business"
            element={
              <TopicPage
                title="E-Commerce Platforms for Small Business: Editorial Comparison"
                description="A current editorial shortlist for small-business priorities, with evidence limitations and methodology context."
                filterKey="small-business"
                path="/best-for-small-business"
              />
            }
          />
          {platforms.map((p) => (
            <Route key={p.slug} path={`/${p.slug}-review`} element={<PlatformReview slug={p.slug} />} />
          ))}
          <Route path="*" element={<NotFound />} />
        </Routes>
        </Suspense>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;

